import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchTranslatorLanguages = createAction(
  actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES,
);
export const fetchTranslatorLanguagesSuccess = createAction(
  actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_SUCCESS,
);
export const fetchTranslatorLanguagesFailure = createAction(
  actionTypes.FETCH_SUPPORTED_AZURE_LANGUAGES_FAILURE,
);

export const fetchTranslatedText = createAction(
  actionTypes.FETCH_TRANSLATED_TEXT,
);
export const fetchTranslatedTextSuccess = createAction(
  actionTypes.FETCH_TRANSLATED_TEXT_SUCCESS,
);
export const fetchTranslatedTextFailure = createAction(
  actionTypes.FETCH_TRANSLATED_TEXT_FAILURE,
);

export const detectLanguage = createAction(
  actionTypes.DETECT_LANGUAGE,
);
export const detectLanguageSuccess = createAction(
  actionTypes.DETECT_LANGUAGE_SUCCESS,
);
export const detectLanguageFailure = createAction(
  actionTypes.DETECT_LANGUAGE_FAILURE,
);

